import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { CategoryItem } from 'features/categories/types/categories.types'

type EditCategoryVariables = {
	id: number
	data: Pick<CategoryItem, 'name'>
}

type UseEditCategoryMutationProps = {
	onSuccess: () => void
}

export const useEditCategoryMutation = ({ onSuccess }: UseEditCategoryMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: editCategoryMutation, isPending: isEditCategoryLoading } = useMutation({
		mutationFn: ({ id, data }: EditCategoryVariables) => {
			return axiosPrivate.patch(apiRoutes.category(String(id)), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.categories.all })
			useToast({ type: 'success', message: t('Category edited') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editCategoryMutation,
		isEditCategoryLoading
	}
}
